<p-breadcrumb [model]="breadcrumb"></p-breadcrumb>
<h1>Vendor Invoice Import</h1>
<main class="vendor-invoice-admin-main">
  <p-tabView>
    <p-tabPanel header="Import Default Configuration">
      <ng-template pTemplate="content">
        <app-invoice-default-configuration></app-invoice-default-configuration>
      </ng-template>
    </p-tabPanel>
    <p-tabPanel header="Invoice Import Items">
      <ng-template pTemplate="content">
        <app-invoice-import-items></app-invoice-import-items>
      </ng-template>
    </p-tabPanel>
    <p-tabPanel header="Vendor Mappings">
      <ng-template pTemplate="content">
        <app-invoice-vendor-mappings></app-invoice-vendor-mappings>
      </ng-template>
    </p-tabPanel>
    <p-tabPanel header="Charge Code Mappings">
      <ng-template pTemplate="content">
        <app-invoice-charge-code-mappings></app-invoice-charge-code-mappings>
      </ng-template>
    </p-tabPanel>
    <p-tabPanel header="Item Mappings">
      <ng-template pTemplate="content">
        <app-invoice-item-mappings></app-invoice-item-mappings>

      </ng-template>
    </p-tabPanel>
  </p-tabView>
</main>

<p-confirmDialog header="Confirmation" icon="fa fa-info" key="vendorInvoiceImport"></p-confirmDialog>
